import { adminRolesAPI } from 'api/admin-roles';
import { FindAllAdminRoleDto } from 'dto/admin-roles';
import { useEffect } from 'react';
import { useQuery } from 'react-query';
import { QUERY_KEY } from 'utils/enums';

type PropsType = {
  filters: FindAllAdminRoleDto;
};

export function useFindAllAdminRole(props: PropsType) {
  const query = useQuery({
    queryKey: QUERY_KEY.FIND_ALL_ADMIN_ROLE,
    queryFn: () => adminRolesAPI.findAll(props.filters),
  });

  useEffect(() => {
    query.refetch();
  }, [props.filters]);

  return {
    query: query,
    count: query.data?.count ?? 0,
    rows: query.data?.rows ?? [],
    loading: query.isLoading || query.isFetching || query.isRefetching,
  };
}
